import { passwordConstants } from "./types";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case passwordConstants.RESET_PASSWORD_REQUEST:
      return {
        ...state,
        ...action.payload,
        success: false
      };
    case passwordConstants.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        success: true
      };
    case passwordConstants.RESET_PASSWORD_FAILURE:
      return {
        error: true,
        success: false
      };
    case passwordConstants.FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        ...action.payload,
        successFirst: false,
      };
    case passwordConstants.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        ...action.payload,
        successFirst: true,
        isOpen: true,
        isOpenEposta : false
      };
    case passwordConstants.FORGOT_PASSWORD_FAILURE:
      return {
        error: true,
        successFirst: false,
        isOpen: false,
        isOpenEposta : false
      };
    case passwordConstants.FORGOTPASS_EPOSTAVERIFY:
      return {
        ...state,
        ...action.payload,
        successFirst: true,
        isOpen: false,
        isOpenEposta : true
      };
    case passwordConstants.FORGOTPASS_EPOSTAVERIFY_FAILURE:
      return {
        error: true,
        successFirst: false,
        isOpen: false,
        isOpenEposta : false
      };
    case passwordConstants.SENDSMS_FORGOT_PASSWORD_REQUEST:
      return {
        ...state,
        ...action.payload,
      };
    case passwordConstants.SENDSMS_FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case passwordConstants.SENDSMS_FORGOT_PASSWORD_FAILURE:
      return {
        error: true,
      };

    case passwordConstants.FORGOTPASS_EPOSTAVERIFY:
      return {
        ...state,
        ...action.payload,
      };
    case passwordConstants.FORGOTPASS_EPOSTAVERIFY_FAILURE:
      return {
        error: true,
      };
    case passwordConstants.HIDE_SMS_MODAL:
      return {
        ...state,
        isOpen: false,
        isOpenEposta : false,
        successFirst: false,
        success: false,
      };
    default:
      return state;
  }
};
